import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MyHttpClient } from '../http-client';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private rulePath = "/api/subscription/rule";
  private ruleByIdPath = "/api/subscription/rule";
  private createrulePath = "/api/accessfee/rule";
  private planByIdPath = "/api/accessfee/plan";
  private fetchPlans = "/api/accessfee/fetchPlans";

  public getApplicableTypes(sdids: string[], modeId?: string) {
    return this.http
      .post(`${environment.server}/api/subscription/applicable-types`, { sdids: sdids || [], modeId })
      .pipe(catchError(this.handleError));
  }

  public getFeedbackContexts(cityId: string, modeId: string) {
    return this.http
      .get(`${environment.server}/api/subscription/feedback-contexts`, { cityId, modeId })
      .pipe(catchError(this.handleError));
  }

  public getSkipServiceHierarchyToggle() {
    return this.http
      .get(`${environment.server}/api/subscription/skip-service-hierarchy`)
      .pipe(catchError(this.handleError));
  }

  public createSubscriptionRules(req: any) {
    return this.http
      .post(environment.server + this.rulePath, req)
      .pipe(catchError(this.handleError));
  }

  public createBillingPlan(req: any) {
    return this.http
      .post(environment.server + this.createrulePath, req)
      .pipe(catchError(this.handleError));
  }

  public getSubscriptionRule(id: string){
    return this.http
    .get(environment.server+this.ruleByIdPath+"/"+id)
    .pipe(catchError(this.handleError));
  }

  public getBillingPlan(id: string){
    return this.http
    .get(environment.server+this.planByIdPath+"/"+id)
    .pipe(catchError(this.handleError));
  }

  public getBillingPlans(payload: any) {
    return this.http
      .post(environment.server + this.fetchPlans, payload)
      .pipe(catchError(this.handleError));
  }

  public updateBillingPlan(planId: string, payload: any) {
    return this.http
      .patch(`${environment.server}/api/accessfee/plan/${planId}`, payload)
      .pipe(catchError(this.handleError));
  }

  public getHighestPriorityHHRule(serviceDetails) {
    return this.http
      .post(`${environment.server}/api/subscription/fetchRules`, {
        filters: {
          serviceDetails: serviceDetails,
          isAutoAssignedToHH: true,
          active: true
        },
        pagination: {
          page: 1,
          pageSize: 1
        },
        queryParams: {
          sortBy: "priority",
          sortOrder: -1
        }
      })
      .pipe(catchError(this.handleError));
  }

  public getHighestPriorityDefaultRule(serviceDetails) {
    return this.http
      .post(`${environment.server}/api/subscription/fetchRules`, {
        filters: {
          serviceDetails: serviceDetails,
          isDefaultSubscription: true,
          active: true
        },
        pagination: {
          page: 1,
          pageSize: 1
        },
        queryParams: {
          sortBy: "priority",
          sortOrder: -1
        }
      })
      .pipe(catchError(this.handleError));
  }

  public getSamePriorityRules(serviceDetails: [string],   startTime: number, endTime: number, priorities: number[]) {
    
    return this.http
      .post(`${environment.server}/api/subscription/fetchRules`, {
        filters: {
          serviceDetails: serviceDetails,
          startTime: startTime,
          endTime: endTime,
          active: true,
          isAutoAssignedToHH: false,
          priorities: (priorities || []).map(p => Number(p))
        },
        pagination: {
          page: 1,
          pageSize: environment.maxRulesCreationAtOnce
        }
      })
      .pipe(catchError(this.handleError))
  }

  public getRules(payload: any) {
    return this.http
      .post(`${environment.server}/api/subscription/fetchRules`, payload)
      .pipe(catchError(this.handleError))
  }

  public getConfigRequests(kind: string, pageNumber: number, pageLimit: number) {
    return this.http
      .get(`${environment.server}/api/subscription-config-requests`, {
        kind,
        pageNumber: String(pageNumber),
        pageLimit: String(pageLimit)
      })
      .pipe(catchError(this.handleError));
  }

  public getConfigRequestById(requestId: string, kind: string) {
    return this.http
      .get(`${environment.server}/api/subscription-config-requests/${requestId}`, { kind })
      .pipe(catchError(this.handleError));
  }

  public decideConfigRequest(requestId: string, action: string, kind: string) {
    return this.http
      .patch(`${environment.server}/api/subscription-config-requests/${requestId}/${action}`, { kind })
      .pipe(catchError(this.handleError));
  }

  public updateRule(ruleId: string,payload: any) {
    return this.http
      .patch(`${environment.server}/api/subscription/rule/${ruleId}`, payload)
      .pipe(catchError(this.handleError))
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, body was:`, error.error);
    }
    return throwError(error);
  }

  constructor(private http: MyHttpClient) { }
}
